import { FC } from 'react';
import { Plans as PlansComponent } from 'components/main/Plans';

const Plans: FC = () => <PlansComponent />;

export default Plans;
